import { Component, Input, ChangeDetectionStrategy, inject } from "@angular/core";
import { ApplicationService } from "../../../lib/services/application.service";

@Component({
    selector: 'section-title',
    template: `
<section class="public-title">
  <p class="public-title__eyebrow">{{applicationService.getApplicationName()}}</p>
  <h1>{{title}}</h1>
  <p class="public-title__subtitle">Il portale per la comunicazione Medico - Paziente</p>
  <div class="public-title__content"><ng-content></ng-content></div>
</section>
    `,
    styles: [`
      .public-title { background: linear-gradient(135deg, #e1f1ee, #f9fcfb); border-bottom: 1px solid #dceae7; padding: clamp(34px, 6vw, 62px) 20px; text-align: center; }
      .public-title__eyebrow { color: #216961; font-size: 13px; font-weight: 700 !important; letter-spacing: .1em; margin: 0 0 8px; text-transform: uppercase; }
      h1 { color: #1d4e49; font-size: clamp(31px, 4.5vw, 48px); font-weight: 700 !important; line-height: 1.12; margin: 0; }
      .public-title__subtitle { color: #607a76; font-size: 16px; margin: 12px 0 0; }
      .public-title__subtitle::after { background: #5eb8ac; border-radius: 999px; content: ''; display: block; height: 4px; margin: 22px auto 0; width: 48px; }
      .public-title__content { background: #fff; border: 1px solid #dceae7; border-radius: 16px; box-shadow: 0 12px 30px rgba(29, 78, 73, .08); margin: 28px auto 0; max-width: 720px; padding: clamp(20px, 4vw, 30px); }
      .public-title__content:empty { display: none; }
    `],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class SectionTitleComponent {
    protected applicationService = inject(ApplicationService);


    @Input() title: string

}
